import { render, staticRenderFns } from "./noSchoolInfo.vue?vue&type=template&id=75530604&"
import script from "./noSchoolInfo.vue?vue&type=script&lang=js&"
export * from "./noSchoolInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports